import { Navigate, Route, Routes } from 'react-router-dom'
import DriverBidsPage from './DriverBidsPage'

export default function DriverBidsRoutes() {
    return (
        <Routes>
            <Route index element={<DriverBidsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
